export default function NeonLoaderOverlay({ label = "Connexion au canal sécurisé…" }) {
  return (
    <div className="fixed inset-0 z-[9998] flex items-center justify-center bg-black">
      <style>{`
        @keyframes spinSlow{to{transform:rotate(360deg)}}
        @keyframes pulseGlow{0%{opacity:.45;filter:blur(0px);transform:scale(0.98)}50%{opacity:.85;filter:blur(1.2px);transform:scale(1.02)}100%{opacity:.45;filter:blur(0px);transform:scale(0.98)}}
        .neon-ring{position:relative;width:110px;height:110px;border-radius:9999px;border:1px solid rgba(129,140,248,.35);box-shadow:0 0 18px rgba(99,102,241,.25),0 0 42px rgba(99,102,241,.18),0 0 72px rgba(99,102,241,.10);}
        .neon-ring::before{content:"";position:absolute;inset:-10px;border-radius:9999px;background:radial-gradient(circle at center,rgba(99,102,241,.22),rgba(99,102,241,.12) 40%,rgba(0,0,0,0) 70%);animation:pulseGlow 1.8s ease-in-out infinite;pointer-events:none;}
        .neon-spinner{position:absolute;inset:12px;border-radius:9999px;border:3px solid rgba(255,255,255,.08);border-top-color:rgba(129,140,248,.9);animation:spinSlow 1.05s linear infinite;}
      `}</style>
      <div className="absolute inset-0 pointer-events-none"><div className="absolute inset-0 opacity-60" style={{ boxShadow: "inset 0 0 240px rgba(0,0,0,.75)" }} /></div>
      <div className="relative flex flex-col items-center gap-4 px-6 text-center">
        <div className="neon-ring"><div className="neon-spinner" /></div>
        <div className="space-y-1">
          <p className="text-[11px] uppercase tracking-[0.24em] text-slate-400">Projet Origami</p>
          <p className="text-sm font-semibold text-slate-100">{label}</p>
          <p className="text-[11px] text-slate-400">Synchronisation de la session…</p>
        </div>
      </div>
    </div>
  );
}